import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-cd6",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-cd6.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-cd6.component.less",
})
export class PrefixCd6Component extends PrefixComponent<string> implements OnInit {
  public maxlength: MaxLength;

  public disabled: boolean;

  public constructor() {
    super({
      defaultValue: "00000",
    });
    this.maxlength = 5;
    this.required = true;
    this.disabled = false;
    this.characters = ALLOWED_CHARACTERS["cd6"];
  }

  protected override setInitialControlValue(value: string | null): void {
    super.setInitialControlValue(value);
    if (value) this.disabled = true;
  }
}
